import React from "react";
import { useState , useMemo, useEffect } from "react";
import TestSpecifique from "../EvalNat/TestSpecifique";
import ResultatParItem from "../EvalNat/ResultatParItem";
import TestSpecifiqueBilan from "./TestSpecifiqueBilan";
import ExportAcquisEvalBilan from "./ExportAcquisEvalBilan";
import ResultatComparatifByEleve from "./ResultatComparatifByEleve";
// Extension explicite : un fichier de même nom à la casse près a existé dans ce dossier (Windows ignore la casse)
import ProgressionComprehension from "./ProgressionComprehension.jsx";
import { bilanSurFormeParallele } from "./progressionParCompetence";
import { formeDuNiveau } from "../../../generators/evalnat/formesParalleles";
// À l'essai : élève par élève, septembre puis aujourd'hui (12/10/2026, à la place de la vue par domaine)
import ProgressionParEleve from "./ProgressionParEleve";
import InterrupteurVue from "./InterrupteurVue";
import { BarChart3, Layers } from "lucide-react";
import { useUser } from "../../../context/UserContext";
import { useClasseContext } from "../../../context/ClasseContext";

const OPTIONS_VUE = [
  { cle: 'actuelle', libelle: 'Vue actuelle' },
  { cle: 'eleves', libelle: 'Élève par élève', essai: true },
];

function AcquisEvalBilan({evalBilan, EvalNat, classe }) {


 
   const [itemNatDetail, setItemNatDetail] = useState({});
   const [ItemBilanDetail, setItemBilanDetail] = useState({});
   const [showDetail, setShowDetail] = useState(false);
   const [testSpecifique, setTestSpecifique] = useState("Automatismes");
   // La vue question par question reste celle par défaut ; la vue élève par élève est à l'essai
   const [vue, setVue] = useState('actuelle');
   const {user} = useUser();
   const {classeNom, groupNom} = useClasseContext();

   // États pour le modal comparatif élève
   const [showEleveModal, setShowEleveModal] = useState(false);
   const [selectedEleveNat, setSelectedEleveNat] = useState(null);
   const [selectedEleveBilan, setSelectedEleveBilan] = useState(null);
   

   const handleTestSpecifiqueClick = (item) => {
    setTestSpecifique(item)
    setItemNatDetail({})
    setItemBilanDetail({})
    setShowDetail(false);
}

   // Fonction pour gérer le clic sur un élève et ouvrir le modal comparatif
   const handleEleveClick = (eleveNom, classeNomEleve) => {
    // Trouver l'élève dans EvalNat
    const eleveNat = correspondancesEvalNat?.eleves_reponses?.find(
      e => e.nom_eleve === eleveNom && e.classe_nom === classeNomEleve
    );

    // Trouver l'élève dans EvalBilan
    const eleveBilan = elevesPresentsEvalBilan?.find(
      e => e.nom_eleve === eleveNom && e.classe_nom === classeNomEleve
    );

    if (eleveNat || eleveBilan) {
      setSelectedEleveNat(eleveNat || null);
      setSelectedEleveBilan(eleveBilan || null);
      setShowEleveModal(true);
    }
  };

  const closeEleveModal = () => {
    setShowEleveModal(false);
    setSelectedEleveNat(null);
    setSelectedEleveBilan(null);
  };


    const elevesPresentsEvalBilan = evalBilan.eleves_reponses.filter(eleve => 
       Object.keys(eleve).length > 4
       ) 
      ;
    
    
    const AutomatismeQuestions = useMemo(() => {
      return evalBilan.questions
        .filter(question => question.type_label === "Automatisme")
        .reduce((acc, question) => {
          const reponses = Array.isArray(question.reponses)
        ? question.reponses.map(rep => {
            return { ...rep };
          })
        : []; // Fallback sur un tableau vide si ce n'est pas un tableau
          
          acc[question.id] = {
            "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
            "reponses": reponses,
            "image": question.image,
            "bonne_reponse": question.bonne_reponse,
            "bonne_reponse_image": question.bonne_reponse_image,
            "id" : question.id,
            "elements_additionnels": question.elements_additionnels,
            "type_question": question.type_question || 'qcm'
          };

          return acc;
        }, {});
    }, [evalBilan.questions]);

    const ProblèmesQuestions = useMemo(() => {
      return evalBilan.questions
        .filter(question => question.type_label === "Résolution de problèmes")
        .reduce((acc, question) => {
          const reponses = Array.isArray(question.reponses)
          ? question.reponses.map(rep => {
              return { ...rep };
            })
          : []; // Fallback sur un tableau vide si ce n'est pas un tableau

          acc[question.id] = {
            "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
            "reponses": reponses,
            "image": question.image,
            "bonne_reponse": question.bonne_reponse,
            "bonne_reponse_image": question.bonne_reponse_image,
            "id" : question.id,
            "elements_additionnels": question.elements_additionnels,
            "type_question": question.type_question || 'qcm'
          };
          
          return acc;
        }, {});
    }, [evalBilan.questions]);


   const AutomatismeQuestionsNat = useMemo(() => {
    // Vérifie si EvalNat.questions est défini et est un tableau
  if (!EvalNat || !EvalNat.questions || !Array.isArray(EvalNat.questions)) {
    return {}; // Retourne un objet vide si EvalNat.questions n'est pas défini ou n'est pas un tableau
  }

  // Vérifie si la classe est undefined et classeNom commence par '5'

      return EvalNat.questions
        .filter(question => question.type_label === "Automatisme")
        .reduce((acc, question) => {
          const reponses = Array.isArray(question.reponses)
        ? question.reponses.map(rep => {
            return { ...rep };
          })
        : []; // Fallback sur un tableau vide si ce n'est pas un tableau
          
          acc[question.question_num] = {
            "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
            "reponses": reponses,
            "image": question.image,
            "bonne_reponse": question.bonne_reponse,
            "question_num": question.question_num,
            "question_id": question.id,
            "elements_additionnels": question.elements_additionnels,
            "type_question": question.type_question || 'qcm'
          };
          
          return acc;
        }, {});
    }, [EvalNat ]);
  
    const ProblèmesQuestionsNat = useMemo(() => {
     // Vérifie si EvalNat.questions est défini et est un tableau
  if (!EvalNat || !EvalNat.questions || !Array.isArray(EvalNat.questions)) {
    return {}; // Retourne un objet vide si EvalNat.questions n'est pas défini ou n'est pas un tableau
  }

  // Vérifie si la classe est undefined et classeNom commence par '5'
 
      return EvalNat.questions
        .filter(question => question.type_label === "Résolution de problèmes")
        .reduce((acc, question) => {
          const reponses = Array.isArray(question.reponses)
          ? question.reponses.map(rep => {
              return { ...rep };
            })
          : []; // Fallback sur un tableau vide si ce n'est pas un tableau
          
          acc[question.question_num] = {
            "question": question.texte, // Utilisez `texte` si c'est le texte de la question que vous voulez
            "reponses": reponses,
            "image": question.image,
            "bonne_reponse": question.bonne_reponse,
            "question_num": question.question_num,
               "question_id": question.id,
               "elements_additionnels": question.elements_additionnels,
            "type_question": question.type_question || 'qcm'
          };
          
          return acc;
        }, {});
    }, [ EvalNat]);

    // Pour EvalBilan - Lexique
const LexiqueQuestionsBilan = useMemo(() => {
  if (evalBilan && evalBilan.questions) {
    return evalBilan.questions
      .filter(question => question.type_label === "Lexique")
      .reduce((acc, question) => {
        const reponses = Array.isArray(question.reponses)
          ? question.reponses.map(rep => {
              return { ...rep };
            })
          : [];
        
        acc[question.id] = {
          "question": question.texte,
          "reponses": reponses,
          "image": question.image,
          "bonne_reponse": question.bonne_reponse,
          "id": question.id,
          "elements_additionnels": question.elements_additionnels,
            "type_question": question.type_question || 'qcm'
        };
        
        return acc;
      }, {});
  } else {
    return {};
  }
}, [evalBilan]);

// Pour EvalBilan - Compréhension de l'écrit
const ComprehensionEcritQuestionsBilan = useMemo(() => {
  if (evalBilan && evalBilan.questions) {
    return evalBilan.questions
      .filter(question => question.type_label.startsWith("Compréhension de l'écrit"))
      .reduce((acc, question) => {
        const reponses = Array.isArray(question.reponses)
          ? question.reponses.map(rep => {
              return { ...rep };
            })
          : [];
        
        // Extraire le nom du texte depuis type_label
        let texteName = question.type_label.replace("Compréhension de l'écrit ", "");
        
        // Si c'est "Document Sommeil", on garde juste "Sommeil"
        if (texteName.startsWith("Document ")) {
          texteName = texteName.replace("Document ", "");
        }
        
        // Pour EvalBilan, on utilise l'id comme clé
        acc[question.id] = {
          "question": question.texte,
          "reponses": reponses,
          "image": question.image,
          "bonne_reponse": question.bonne_reponse,
          "id": question.id,
          "category": texteName, // On garde la catégorie pour référence
          "elements_additionnels": question.elements_additionnels,
            "type_question": question.type_question || 'qcm'
        };
        
        return acc;
      }, {});
  } else {
    return {};
  }
}, [evalBilan]);

// Pour EvalBilan - Compétences langagières et linguistiques
const CompetencesLangagiereQuestionsBilan = useMemo(() => {
  if (evalBilan && evalBilan.questions) {
    return evalBilan.questions
      .filter(question => question.type_label === 'Compétences langagières et linguistiques')
      .reduce((acc, question) => {
        const reponses = Array.isArray(question.reponses)
          ? question.reponses.map(rep => {
              return { ...rep };
            })
          : [];
        
        acc[question.id] = {
          "question": question.texte,
          "reponses": reponses,
          "image": question.image,
          "bonne_reponse": question.bonne_reponse,
          "id": question.id,
          "elements_additionnels": question.elements_additionnels,
            "type_question": question.type_question || 'qcm'
        };
        
        return acc;
      }, {});
  } else {
    return {};
  }
}, [evalBilan]);

// Pour EvalNat - Lexique
const LexiqueQuestionsNat = useMemo(() => {
  if (!EvalNat || !EvalNat.questions || !Array.isArray(EvalNat.questions)) {
    return {};
  }
  
  return EvalNat.questions
    .filter(question => question.type_label === "Lexique")
    .reduce((acc, question) => {
      const reponses = Array.isArray(question.reponses)
        ? question.reponses.map(rep => {
            return { ...rep };
          })
        : [];
      
      acc[question.question_num] = {
        "question": question.texte,
        "reponses": reponses,
        "image": question.image,
        "bonne_reponse": question.bonne_reponse,
        "question_num": question.question_num,
        "question_id": question.id,
        "elements_additionnels": question.elements_additionnels,
            "type_question": question.type_question || 'qcm'
      };
      
      return acc;
    }, {});
}, [EvalNat]);

// Pour EvalNat - Compréhension de l'écrit
const ComprehensionEcritQuestionsNat = useMemo(() => {
  if (!EvalNat || !EvalNat.questions || !Array.isArray(EvalNat.questions)) {
    return {};
  }
  
  return EvalNat.questions
    .filter(question => question.type_label.startsWith("Compréhension de l'écrit"))
    .reduce((acc, question) => {
      const reponses = Array.isArray(question.reponses)
        ? question.reponses.map(rep => {
            return { ...rep };
          })
        : [];
      
      // Extraire le nom du texte depuis type_label
      let texteName = question.type_label.replace("Compréhension de l'écrit ", "");
      
      // Si c'est "Document Sommeil", on garde juste "Sommeil"
      if (texteName.startsWith("Document ")) {
        texteName = texteName.replace("Document ", "");
      }
      
      // Créer la clé composite "Arachné Q1" ou "Sommeil Q1"
      const cleComposite = `${texteName} ${question.question_num}`;
      
      acc[cleComposite] = {
        "question": question.texte,
        "reponses": reponses,
        "image": question.image,
        "bonne_reponse": question.bonne_reponse,
        "question_num": question.question_num,
        "question_id": question.id,
        "elements_additionnels": question.elements_additionnels,
            "type_question": question.type_question || 'qcm'
      };
      
      return acc;
    }, {});
}, [EvalNat]);

// Pour EvalNat - Compétences langagières et linguistiques
const CompetencesLangagieresQuestionsNat = useMemo(() => {
  if (!EvalNat || !EvalNat.questions || !Array.isArray(EvalNat.questions)) {
    return {};
  }
  
  return EvalNat.questions
    .filter(question => question.type_label === 'Compétences langagières et linguistiques')
    .reduce((acc, question) => {
      const reponses = Array.isArray(question.reponses)
        ? question.reponses.map(rep => {
            return { ...rep };
          })
        : [];
      
      acc[question.question_num] = {
        "question": question.texte,
        "reponses": reponses,
        "image": question.image,
        "bonne_reponse": question.bonne_reponse,
        "question_num": question.question_num,
           "question_id": question.id,
           "elements_additionnels": question.elements_additionnels,
            "type_question": question.type_question || 'qcm'
      };
      
      return acc;
    }, {});
}, [EvalNat]);

// Définir les boutons selon matière et niveau
const getTestButtons = (matiere, niveau) => {
  const buttons = [];
  
  if (matiere === 'maths') {
    // Automatismes pour tous
    buttons.push({ key: 'Automatismes', label: '📊 Automatismes' });
    // Problèmes seulement pour 6ème et 4ème
    if (niveau === '6' || niveau === '4') {
      buttons.push({ key: 'Problèmes', label: '📋 Résolutions de problèmes' });
    }
  } else if (matiere === 'Français') {
    switch(niveau) {
      case '6':
        buttons.push({ key: 'Lexique', label: '📚 Lexique' });
        buttons.push({ key: 'ComprehensionEcrite', label: '📖 Compréhension écrite' });
        break;
      case '5':
        buttons.push({ key: 'CompetencesLangagieres', label: '💬 Compétences langagières' });
        break;
      case '4':
        buttons.push({ key: 'Lexique', label: '📚 Lexique' });
        buttons.push({ key: 'ComprehensionEcrite', label: '📖 Compréhension écrite' });
        break;
      default:
        buttons.push({ key: 'Lexique', label: '📚 Lexique' });
        buttons.push({ key: 'ComprehensionEcrite', label: '📖 Compréhension écrite' });
        break;
    }
  }
  
  return buttons;
}

// Dans le JSX
const niveau = groupNom ? groupNom[0] : (classeNom && classeNom[0]);
const buttons = getTestButtons(user.matiere && user.matiere, niveau);
// L'onglet ouvert doit exister dans la matière (12/10/2026) : l'écran s'ouvrait sur « Automatismes » en français,
// et disait à tort qu'il n'y avait aucune donnée d'évaluation nationale
const premierOnglet = buttons[0]?.key;
const ongletExiste = buttons.some((b) => b.key === testSpecifique);
useEffect(() => {
  if (premierOnglet && !ongletExiste) setTestSpecifique(premierOnglet);
}, [premierOnglet, ongletExiste]);
// Combien d'élèves ont rendu ce QCM : avec très peu de copies, un pourcentage ne dit rien de la classe
const nbCopiesRendues = elevesPresentsEvalBilan?.length || 0;
const nbCopies = evalBilan.eleves_reponses?.length || 0;
// Compréhension de l'écrit passée sur une forme parallèle (11/10/2026) : d'autres textes que septembre, donc
// une comparaison par support et par compétence à la place de la comparaison question par question
const formeParallele = formeDuNiveau(niveau);
const surFormeParallele = testSpecifique === 'ComprehensionEcrite' && bilanSurFormeParallele(evalBilan.questions, formeParallele);


    // Créer un tableau de noms des élèves présents dans evalBilan
    const nomsElevesEvalBilan = elevesPresentsEvalBilan?.map(eleve => eleve.nom_eleve);
   
    

    // Filtrer EvalNat pour ne récupérer que les élèves dont les noms correspondent
    let correspondancesEvalNat = {}
  
    correspondancesEvalNat = { ...EvalNat, eleves_reponses : EvalNat.eleves_reponses.filter(eleveNat => 
      nomsElevesEvalBilan.includes(eleveNat.nom_eleve)
    )};

  


    const handleItemClick = (item) => {
      setShowDetail(true);
      setItemBilanDetail({})
      if(item.bilan){
        setItemBilanDetail(item.statsbilan[item.question_id]);
        const natDetail = item.statsnat?.[item.displayLabel || item.question_id];
        setItemNatDetail(natDetail || null);
        return;
      } else{
      setItemNatDetail(item);
      }
 }



return (
  <div className="min-h-screen">
    {/* Header */}
    <div className="bg-white rounded-2xl shadow-md border border-gray-100 mb-6 overflow-hidden">
      <div className="bg-gradient-to-r from-blue-600 via-cyan-500 to-sky-400 px-6 py-5">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-2.5 bg-white/20 backdrop-blur rounded-xl">
              <BarChart3 className="w-6 h-6 text-white" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-white">Analyse comparative</h2>
              <p className="text-white/80 text-sm">"{evalBilan.titre}" vs Évaluation Nationale</p>
            </div>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <InterrupteurVue
              surFondColore
              etiquette="Affichage de la progression"
              options={OPTIONS_VUE}
              valeur={vue}
              onChange={setVue}
            />
            {correspondancesEvalNat && elevesPresentsEvalBilan &&
              <ExportAcquisEvalBilan EvalNat={correspondancesEvalNat} evalBilan={elevesPresentsEvalBilan} evalBilanQuestions={evalBilan.questions} />
            }
          </div>
        </div>
      </div>

      {/* Category selector (vue actuelle) */}
      {vue === 'actuelle' ? (
      <div className="px-6 py-4 bg-gray-50 border-b border-gray-100">
        <div className="flex flex-wrap gap-2">
          {buttons.map(button => (
            <button
              key={button.key}
              className={`px-5 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 ${
                testSpecifique === button.key
                  ? 'bg-blue-600 text-white shadow-md shadow-blue-200'
                  : 'bg-white text-gray-600 border border-gray-200 hover:border-blue-300 hover:bg-blue-50'
              }`}
              onClick={() => handleTestSpecifiqueClick(button.key)}
            >
              {button.label}
            </button>
          ))}
        </div>
      </div>
      ) : null}

      {/* Combien d'élèves ont rendu ce QCM (12/10/2026) : sans ce nombre, 100 % ou −23 points se lisent comme ceux
          de la classe alors qu'ils sont ceux d'un seul élève */}
      {nbCopiesRendues < nbCopies ? (
        <p className="px-6 py-3 bg-amber-50 border-t border-amber-100 text-sm text-amber-900">
          <span className="font-semibold">
            {nbCopiesRendues} élève{nbCopiesRendues > 1 ? 's' : ''} sur {nbCopies} {nbCopiesRendues > 1 ? 'ont' : 'a'} rendu ce QCM.
          </span>
          {nbCopiesRendues > 0 && nbCopiesRendues < 5
            ? ` Les pourcentages ci-dessous sont ceux de ${nbCopiesRendues > 1 ? 'ces élèves' : 'cet élève'} seulement : ils ne disent rien de la classe.`
            : ' Les comparaisons portent sur les élèves qui l’ont rendu.'}
        </p>
      ) : null}
    </div>

    {/* Élève par élève, à l'essai : chaque question en septembre puis aujourd'hui */}
    {vue === 'eleves' ? (
      <ProgressionParEleve
        evalNat={EvalNat}
        evalBilan={evalBilan}
        forme={bilanSurFormeParallele(evalBilan.questions, formeParallele) ? formeParallele : null}
      />
    ) : null}

    {/* Compréhension sur une forme parallèle : par support et par compétence */}
    {vue === 'actuelle' && surFormeParallele ? <ProgressionComprehension evalNat={EvalNat} evalBilan={evalBilan} forme={formeParallele} /> : null}

    {/* Main content: sidebar + detail (question par question) */}
    <div className={vue !== 'actuelle' || surFormeParallele ? 'hidden' : 'flex flex-col xl:flex-row gap-6'}>
      {/* Sidebar - Question list */}
      <div className="xl:w-[420px] flex-shrink-0">
        <div className="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
          <div className="px-5 py-4 border-b border-gray-100 flex items-center gap-2">
            <Layers className="w-5 h-5 text-blue-600" />
            <h3 className="font-semibold text-gray-800">Questions</h3>
          </div>
          {elevesPresentsEvalBilan && elevesPresentsEvalBilan.length > 0 && testSpecifique && Object.keys(correspondancesEvalNat).length !== 0 && (
            <TestSpecifiqueBilan
              EvalNat={correspondancesEvalNat}
              evalBilan={elevesPresentsEvalBilan}
              handleItemClick={handleItemClick}
              testSpecifique={testSpecifique}
              questionsBilan={evalBilan.questions}
            />
          )}
        </div>
      </div>

      {/* Detail panels */}
      {showDetail && (
        <div className="flex-1 flex flex-col lg:flex-row gap-6 min-w-0">
          {/* National detail — affiché seulement si on a des données nat pour cette question */}
          {itemNatDetail && Object.keys(itemNatDetail).length > 0 && (
            <div className="flex-1 bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden min-w-0">
              {(Object.keys(correspondancesEvalNat).length !== 0) ?
                <ResultatParItem itemDetail={itemNatDetail} testSpecifique={testSpecifique}
                  AutomatismeQuestions={AutomatismeQuestionsNat} ProblèmesQuestions={ProblèmesQuestionsNat}
                  LexiqueQuestion={LexiqueQuestionsNat}
                  CompetencesLangagieresQuestion={CompetencesLangagieresQuestionsNat}
                  ComprehensionEcritQuestion={ComprehensionEcritQuestionsNat}
                  bilan={true}
                  onEleveClick={handleEleveClick} />
              :
                <ResultatParItem itemDetail={itemNatDetail} testSpecifique={testSpecifique}
                  AutomatismeQuestions={AutomatismeQuestions} ProblèmesQuestions={ProblèmesQuestions}
                  LexiqueQuestion={LexiqueQuestionsNat}
                  CompetencesLangagieresQuestion={CompetencesLangagieresQuestionsNat}
                  ComprehensionEcritQuestion={ComprehensionEcritQuestionsNat}
                  bilan={true}
                  onEleveClick={handleEleveClick} />
              }
            </div>
          )}

          {/* Bilan detail */}
          {ItemBilanDetail && Object.keys(ItemBilanDetail).length > 0 && (
            <div className="flex-1 bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden min-w-0">
              <ResultatParItem itemDetail={ItemBilanDetail} testSpecifique={testSpecifique} bilan={true}
                AutomatismeQuestions={AutomatismeQuestions} ProblèmesQuestions={ProblèmesQuestions}
                LexiqueQuestion={LexiqueQuestionsBilan}
                CompetencesLangagieresQuestion={CompetencesLangagiereQuestionsBilan}
                ComprehensionEcritQuestion={ComprehensionEcritQuestionsBilan}
                onEleveClick={handleEleveClick}
              />
            </div>
          )}
        </div>
      )}
    </div>

    {/* Modal comparatif élève */}
    <ResultatComparatifByEleve
      show={showEleveModal}
      onClose={closeEleveModal}
      eleveNat={selectedEleveNat}
      eleveBilan={selectedEleveBilan}
      EvalNat={correspondancesEvalNat}
      evalBilan={evalBilan}
      testSpecifique={testSpecifique}
    />
  </div>
)

}

export default AcquisEvalBilan;